import axios from 'axios';
import { EntryPicks, BPSFixture } from '../../types';


const API_BASE_URL = process.env.REACT_APP_API_URL;

// --- small helpers ---
export const fetchJson = async <T,>(path: string): Promise<T> => {
    const { data } = await axios.get<T>(`${API_BASE_URL}${path}`);
    return data;
};

export const fetchPicksData = async (entryId: number, currentEvent: number) => {

    const picksResp = await fetchJson<EntryPicks>(`/api/${entryId}/event/${currentEvent}/managerTeam`);
    const picks = picksResp.picks ?? [];
    const activeChip = (picksResp.active_chip || '').toUpperCase();
    const transferCost = picksResp.entry_history.event_transfers_cost || 0;

    return { picks, activeChip, transferCost };

}

export const calculateBonusPoints = (
    top3players: Array<[string, number]>
): Map<number, number> => {
    if (top3players.length === 0) {
        throw new Error("calculateBonusPoints - No bonus points to allocate");
    }

    const sortedArr = top3players.map(([id, bps]) => [Number(id), bps] as [number, number]);

    const awards = [3, 2, 1];

    const out = new Map<number, number>();
    let i = 0, awardIdx = 0;
    while (i < sortedArr.length && awardIdx < awards.length) {
        //Get current bps score
        const currentBps = sortedArr[i][1];
        const sameBand: number[] = [];
        while (i < sortedArr.length && sortedArr[i][1] === currentBps) {
            sameBand.push(sortedArr[i][0]);
            i++;
        }

        for (const id of sameBand) {
            out.set(id, awards[awardIdx]);
        }

        awardIdx++;

    }

    return out;
};


export const getLiveBonusPointsForFixture = (fixture: BPSFixture) => {
    if (fixture.a == null && fixture.h == null) return;
    const allPlayersBonusForFixture = [
        ...(fixture.h || []),
        ...(fixture.a || [])
    ];


    const playerPointsArray = Object.fromEntries(allPlayersBonusForFixture.map(p => [p.element, p.value]));
    const playersSortedPoints = Object.entries(playerPointsArray)
        .sort((a, b) => b[1] - a[1]); // Sort by score desc

    // Get the highest 3 distinct score values (ES5 safe)
    const top3Scores = Array.from(
        new Set(playersSortedPoints.map(([_, score]) => score))
    ).slice(0, 3);

    // Keep all players whose score is one of the top 3 distinct scores
    const topPlayers = playersSortedPoints.filter(([_, score]) => top3Scores.includes(score));

    const bonusPointsMap = calculateBonusPoints(topPlayers);

    return bonusPointsMap;

}
